import { useEffect, useState } from 'react';
import { Card, Row, Col, Radio, message } from 'antd';
import { api } from '../../components/Api/api';
import Loading from '../../components/Loading';
import theme1 from "../../img/theme-1.png";
import theme2 from "../../img/theme-2.png";
import theme3 from "../../img/theme-3.png";

const Theme = () => {
  const [themeId, setThemeId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    let active = true;

    const fetchTheme = async () => {
      try {
        const res = await api.get('/template/theme');
        if (active) {
          setThemeId(res.data.theme_id == null ? null : Number(res.data.theme_id));
        }
      } catch (err) {
        if (active) {
          message.error('Không thể tải giao diện hiện tại.');
        }
      } finally {
        if (active) {
          setLoading(false);
        }
      }
    };

    fetchTheme();
    return () => { active = false; };
  }, []);

  const handleChange = async (event) => {
    const nextThemeId = event.target.value;
    if (saving || nextThemeId === themeId) return;

    const previousThemeId = themeId;
    setThemeId(nextThemeId);
    setSaving(true);
    try {
      const res = await api.put('/template/theme', { theme_id: nextThemeId });
      message.success(res.data.msg || 'Cập nhật giao diện thành công.');
    } catch (err) {
      setThemeId(previousThemeId);
      message.error('Không thể cập nhật giao diện. Vui lòng thử lại.');
    } finally {
      setSaving(false);
    }
  };

  const themes = [
    {
      theme_id: 1,
      imageSrc: theme1,
      title: 'Giao diện 1',
    },
    {
      theme_id: 2,
      imageSrc: theme2,
      title: 'Giao diện 2',
    },
    {
      theme_id: 3,
      imageSrc: theme3,
      title: 'Giao diện 3',
    },
  ];

  if (loading) return <Loading />;

  return (
    <Radio.Group
      name="theme"
      value={themeId}
      onChange={handleChange}
      disabled={saving}
      style={{ width: '100%' }}
    >
      <Row gutter={[16, 16]} justify='flex-start'>
        {themes.map((theme) => (
          <Col key={theme.theme_id} xs={24} sm={12} md={8} lg={6}>
            <Card hoverable style={{ width: '100%', borderColor: themeId === theme.theme_id ? '#1677ff' : undefined }}>
              <label
                htmlFor={`theme-${theme.theme_id}`}
                style={{
                  display: 'block',
                  width: '100%',
                  height: '150px',
                  overflow: 'hidden',
                  cursor: saving ? 'not-allowed' : 'pointer'
                }}
              >
                <img src={theme.imageSrc}
                  alt={theme.title}
                  style={{
                    objectFit: 'cover',
                    width: '100%',
                    height: '100%'
                  }}
                />
              </label>
              <div style={{ padding: '16px' }}>
                <Radio id={`theme-${theme.theme_id}`} value={theme.theme_id}>{theme.title}</Radio>
              </div>
            </Card>
          </Col>
        ))}
      </Row>
    </Radio.Group>
  );
};

export default Theme;
